import { useState } from "react";
import Overheads from "@/components/Overheads";

import { nzNow } from "@/lib/dates";
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function BackEndExpensesCard({ api, year, months, staff, settings, reload }) {
  const [month, setMonth] = useState(MONTHS[nzNow().getMonth()]);
  const record = (months || []).find((m) => m.month === month);
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <label className="text-xs font-semibold uppercase tracking-wider text-[var(--hp-muted)]">Month</label>
        <select data-testid="backend-expenses-month-select" value={month} onChange={(e) => setMonth(e.target.value)}
          className="rounded-full border border-[var(--hp-border-hi)] bg-[var(--hp-bg)] px-3 py-1.5 text-xs font-semibold text-[var(--hp-heading)]">
          {MONTHS.map((m) => <option key={m} value={m}>{m} {year}</option>)}
        </select>
      </div>
      <Overheads api={api} year={year} month={month} record={record} staff={staff || []} settings={settings} reload={reload} />
    </div>
  );
}
